import * as XState from "xstate";
import cabri from "../../app/cabri-app";
import {LOG} from '../../app/log'


export default XState.Machine({
        id: "turn_tool",
        initial: "inactive",
        context: {
            permanent: true,
            lastPointer: {},
            lastTurnTime: 0,
            speed: {},
            lastPointerSpeed: 0,
            lastR: 0,
        },
        states: {
            "selected": {
                on: {
                    START: {target: "turning"},
                    CANCEL: {target: "inactive"},
                },
            },
            "turning": {
                on: {
                    MOVE: {target: undefined, actions: ["turn"]},
                    DROP: {target: "selected", actions: ["launchIfNeeded"]},
                    CANCEL: {target: "inactive"},
                },
            },
            "inactive": {
                on: {ACTIVATE: {target: "selected"}},
            },
        },
    },
    {
        actions: {
            turn: (ctx, evt) => {
                const prevPointer = ctx.lastPointer, now = new Date().getTime();
                let timeSinceLastEvent = now - ctx.lastTurnTime;
                cabri.camera.autoRotate = null;
                const t = cabri.camera.getTarget(), o = cabri.camera.position;
                const r = Math.sqrt(
                    (t.x - o.x) ** 2 + (t.y - o.y) ** 2
                    + (t.z - o.z) ** 2) * 48 / 2;
                let move = {
                    x: 10 * (evt.mousePos.x - prevPointer.x),
                    y: 10 * (evt.mousePos.y - prevPointer.y),
                };
                ctx.speed = move;
                ctx.lastR = r;
                ctx.lastPointerSpeed = Math.sqrt(
                        Math.pow(move.x, 2) + Math.pow(move.y, 2))
                    / (timeSinceLastEvent / 1000);
                let plusA = Math.asin(-move.x / r),
                    plusB = Math.asin(-move.y / r);
                if (!(Number.isNaN(plusA) || Number.isNaN(plusB))) {
                    cabri.camera.alpha =
                        cabri.camera.alpha + plusA;
                    cabri.camera.beta =
                        cabri.camera.beta + plusB;
                }
                ctx.lastPointer = evt.mousePos;
                ctx.lastMove = move;
                ctx.lastTurnTime = now;
                if (cabri.camera.autoRotate)
                    cabri.camera.autoRotate = null;
            },
            launchIfNeeded: (ctx, evt) => {
                // this one is really difficult to calibrate, we may need more
                // numbers (e.g. speed 0.5s before)
                LOG.for("turn-tool-state") && LOG.info("LastPointerSpeed: " + ctx.lastPointerSpeed);
                if (ctx.lastPointerSpeed > 150) {
                    ctx.lastPointerSpeed = 0;
                    // interpret a launch
                    cabri.camera.autoRotate =
                        {
                            dAlpha: Math.asin(-ctx.lastMove.x / ctx.lastR),
                            dBeta: Math.asin(-ctx.lastMove.y / ctx.lastR),
                            lastEventTime: new Date().getTime(),
                        };
                    LOG.for("turn-tool-state") && LOG.info("Throw! ",cabri.camera.autoRotate);

                }
                ctx.timeLastEvent = new Date().getTime();

            },
        },

    });

